export const statusPropostasEnum = {
  emProcessamento: "Em Processamento",
  rejeitado: "Rejeitada",
  aprovado: "Aprovada",
  execucaoIniciada: "Em execução",
};
